import {
  of as observableOf,
  throwError as observableThrowError,
  Subscription,
  Observable,
  BehaviorSubject,
  interval,
  throwError,
  of
} from 'rxjs';
import { tap, mergeMap, catchError, map, flatMap, finalize, take, switchMap } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import {
  TaskDTO,
  ActionDTO,
  ActionTypeDTO,
  Link,
  WorkDTO,
  TaskStatusDTO,
  TaskTypeDTO
} from '../../app/api/plyca-dtos';
import { Configuration } from '../../app/conf/app.constants';
import { AppState } from '../store/AppState';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ADD_OPENEDTASK, DELETE_OPENEDTASK } from '../store/openedTasks';
import { OpenedTaskInfo, ViewModel } from '../api/OpenedTaskInfo';
import { ServiceLocator } from './../ServiceLocator';
import { UPDATE_PENDINGTASK, DELETE_PENDINGTASK, SET_DOSSIER_PENDINGTASKS, SET_PENDINGTASKS } from '../store/pendingTasks';
import { UIService } from '../ui.service';
import { PaginationDTO } from '../api/PaginationModel';
import { PlycaDataService } from '../../services/plyca.service';
import { UserService } from '../user.service';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpClient
} from '../../../node_modules/@angular/common/http';
import { HelpService } from '../components/common/help/help.service';
import { AppConfiguration } from '../../app/conf/app.configuration';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { BaseDirectiveObject } from '../components/common/base-directive-object';

@Injectable()
export class TaskService extends BaseDirectiveObject implements OnDestroy {
  public openedTasks: Observable<OpenedTaskInfo>;
  public uiService: UIService;
  private router: Router;
  public plycaService: PlycaDataService;
  private translationService: TranslateService;

  // subscripcion a la lista de tareas pendientes
  pendingTasks: Observable<any>;
  taskThread: Subscription;

  private loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  loadingStatusObservable: Observable<boolean> = this.loading.asObservable();

  private lastLoad: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);
  lastLoadObservable: Observable<Date> = this.lastLoad.asObservable();
  MOSTRAR_MENSAJE_TAREAS_NUEVAS = true;
  NO_MOSTRAR_MENSAJE_TAREAS_NUEVAS = false;

  constructor(
    private appConfig: AppConfiguration,
    plycaService: PlycaDataService,
    public userService: UserService,
    public helpService: HelpService,
    private _http: HttpClient,
    private _configuration: Configuration,
    private store: Store<AppState>,
    private waitService: WaitLoadingService
  ) {
    super();
    this.router = ServiceLocator.injector.get(Router);
    this.uiService = ServiceLocator.injector.get(UIService);
    this.plycaService = plycaService;
    this.pendingTasks = this.store.select('pendingTasks');
    this.translationService = ServiceLocator.injector.get(TranslateService);
  }

  ngOnDestroy() {
    this.loading = undefined;
    this.lastLoad = undefined;
    this.stopTasksThread();
    super.ngOnDestroy();
  }

  // este metodo es el mas complejo porque parte de un id de tarea y no de un TASKDTO
  public lockTask(taskId: string, withActions = false, showHelp = true): Observable<TaskDTO> {

    return this.internalLockTask(taskId).pipe(

      mergeMap(() => withActions ? this.getTaskWithActions(taskId) : this.getTaskForWork(taskId)),
      switchMap((task: TaskDTO) => {
        let obs: Observable<TaskDTO>;

        let taskInfo: OpenedTaskInfo = new OpenedTaskInfo();
        taskInfo.taskId = task.identifier;
        taskInfo.taskDTO = task;
        taskInfo.model = new ViewModel();
        // cargamos aqui la ayuda asociada a la tarea
        if (showHelp) {
          obs = this.helpService.showContextHelpObservable(task)
            .pipe(
              map(() => task)
            );

        } else {
          obs = of(task);
        }
        this.store.dispatch(ADD_OPENEDTASK({ task: taskInfo }));
        return obs;
      }),
      catchError(error => {
        // this.plycaErrorHandler.handle(error);


        return observableThrowError(error)
      })
    );

  }

  public unlockTask(task: TaskDTO, showWait = true): Observable<any> {
    if (showWait) {
      this.waitService.startWaiting();
    }
    return this.internalUnlockTask(task).pipe(
      flatMap(() => {
        this.removeFromOpenedStore(task);
        return this.getTaskWithoutWork(task.identifier)
          .pipe(finalize(() => {
            if (showWait) {
              this.waitService.cancelWaiting();
            }
          }));
      }),
      catchError(error => {
        if (showWait) {
          this.waitService.cancelWaiting();
        }
        return throwError(error);
      })
    );

  }

  public redirectTask(task: TaskDTO, inboxIdentifier: string): Observable<any> {
    this.waitService.startWaiting();
    return this.internalRedirectTask(task, inboxIdentifier).pipe(
      tap(() => {
        this.subscribe(this.consultaTareasObservable()
          .pipe(finalize(() => {
            this.waitService.cancelWaiting();
          })));
      }),
      catchError(error => {
        this.waitService.cancelWaiting();
        return throwError(error);
      })
    );

  }

  public keepTask(task: TaskDTO): Observable<any> {
    return this.internalKeepTask(task).pipe(
      tap(() => {
        this.removeFromOpenedStore(task);
        this.subscribe(this.getTaskWithoutWork(task.identifier));
      })
    );
    // .catch((err: any) => {
    //   let resp: any = '';
    //   if (err.json) {
    //     try {
    //       resp = err.json();
    //     } catch (e) {
    //       console.log((<Error>e).message);
    //     }
    //   }
    //   console.log(err, resp);
    //   this.uiService.showMessage(err);
    //   return Observable.throw(err);
    // });
  }

  public dispatchTask(task: TaskDTO): Observable<any> {
    return this.internalDispatchTask(task).pipe(
      tap(() => {
        this.removeFromOpenedStore(task);
        this.store.dispatch(DELETE_PENDINGTASK({ identifier: task.identifier }));
      })
    );
    // .catch((err: any) => {
    //   let resy = '';
    //   if (err.json) {
    //     try {
    //       resp = err.json();
    //     } catch (e) {
    //       console.log((<Error>e).message);
    //     }
    //   }
    //   console.log(err, resp);
    //   return Observable.throw(err);
    // });
  }

  public processAction(
    task: TaskDTO,
    updatedWork: WorkDTO,
    action: ActionDTO
  ): Observable<any> {
    let url: string = action.links[0].href;
    return this._http.put(url, this.work2String(updatedWork)).pipe(
      tap(() => {
        this.removeFromOpenedStore(task);
        this.store.dispatch(DELETE_PENDINGTASK({ identifier: task.identifier }));
      })
    );
  }

  private removeFromOpenedStore(task: TaskDTO) {
    if (task) {
      let taskInfo: OpenedTaskInfo = new OpenedTaskInfo();
      taskInfo.taskId = task.identifier;
      taskInfo.taskDTO = task;
      taskInfo.model = new ViewModel();
      this.store.dispatch(DELETE_OPENEDTASK({ task: taskInfo }));
    }
  }

  openTask(task: TaskDTO): void {
    console.log('Tarea READY');
    this.router.navigate(['task', task.identifier]);
  }

  consultaTareas(mostrarMensaje?: boolean) {
    this.subscribe(this.consultaTareasObservable(null, mostrarMensaje));
  }

  consultaTareasObservable(dossierId?: String, mostrarMensaje?: boolean): Observable<any> {
    let tareasTmp: TaskDTO[];
    let updatingByDossier = dossierId !== undefined && dossierId != null;
    this.loading.next(true);

    // .getTasks ("fromDate=20150101 00:00:00")
    let taskPageParam = updatingByDossier ? 'dossierId=' + dossierId : null;
    return this.getTasksPage(0, 9999, taskPageParam).pipe(
      tap((param: PaginationDTO<TaskDTO>) => {
        tareasTmp = param ? param.content : [];
        let action;
        let payload;
        if (updatingByDossier) {
          action = SET_DOSSIER_PENDINGTASKS;
          payload = { tasks: tareasTmp, dossierId: dossierId };
        } else {
          action = SET_PENDINGTASKS;
          payload = { tasks: tareasTmp };
        }

        // si no es la primera vez comprobamos las tareas nuevas
        if (param && param.content) {
          // si mostrar mensaje no tiene valor (invocacion al metodo sin parametros) o llega true

          if (mostrarMensaje === undefined || mostrarMensaje) {
            let tareasNuevas: TaskDTO[] = [];

            this.pendingTasks.pipe(
              take(1) // cerrar suscripcion automaticamente tras primera emision del observable
            ).subscribe((pendingTasks: TaskDTO[]) => {
              tareasTmp.forEach((x: TaskDTO) => {
                let existeTarea = pendingTasks.find((oldx: TaskDTO) => x.identifier === oldx.identifier);
                if (!existeTarea) {
                  tareasNuevas.push(x);
                }
              });
              this.addInfoNoExpandida();
              this.store.dispatch(action(payload));

              if (tareasNuevas && tareasNuevas.length > 0) {
                this.uiService.showSuccess(
                  this.translationService.instant('Tasks.new.warn', { tasknumber: tareasNuevas.length }),
                  this.translationService.instant('General.warn')
                );
              }
            });
          } else {
            // ACTUALIZAR EL STORE CON LAS TAREAS RECIBIDAS

            // OJO. ÑAPA. Esta búsqueda debiera ser innecesaria. Se introduce por que las expansiones en cliente
            // no están funcionando correctamente en un caso concreto
            // Ocurre un problema cuando se pone un objeto varias veces. En el ej. de la búsqueda de tareas
            // (getTasksPage) el problema lo presenta el objeto división
            this.addInfoNoExpandida();
            this.store.dispatch(action(payload));
          }
        } else {
          tareasTmp = [];
          // OJO. ÑAPA. Esta búsqueda debiera ser innecesaria. Se introduce por que las expansiones en cliente
          // no están funcionando correctamente en un caso concreto
          // Ocurre un problema cuando se pone un objeto varias veces. En el ej. de la búsqueda de tareas
          // (getTasksPage) el problema lo presenta el objeto división
          this.addInfoNoExpandida();
          this.store.dispatch(action(payload));
        }
        this.loading.next(false);
        this.lastLoad.next(new Date());
      })
    );
  }

  private addInfoNoExpandida() { }

  /*
   * INVOCACIONES A LAS APIS
   */
  public getTasksPage = (
    page: number,
    size: number,
    params?: string
  ): Observable<PaginationDTO<TaskDTO>> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'tasks?page=' +
      page +
      '&size=' +
      size +
      '&expand=expansionSet:client_tasks';
    if (params) {
      url += '&' + params;
    }
    return this._http
      .get<PaginationDTO<TaskDTO>>(url);
  };

  public getCSVTasks(params: string) {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'tasks' +
      '?expand=expansionSet:client_tasks';
    if (params) {
      url += '&' + params;
    }
    return this.plycaService
      .getCSVFromService(url, this.translationService.instant('General.tasks'));
  }

  /*
  public getTasksPageFiltered = (page: number, size: number, dossierId: string,
    vertareasbloqueadas: boolean): Observable<PaginationDTO<TaskDTO>> => {
    let url = this._configuration.ServerWithUserApiUrl + "tasks?page=" + page + "&size=" + size;
    //+"&dossier="+dossierId+"&expand=dossier.*,dossier.division.*,dossier.division.procedure";
    url = vertareasbloqueadas ? url + "&displayLckd=true&displayLogicallyLckd=true" : url + "&displayLckd=false&displayLogicallyLckd=false";
    console.log('getTasksPageFiltered URL: ' + url);
    return this._http.get(url)
      .map((response: Response) => {
        return response.json() as PaginationDTO<TaskDTO>;
      }).catch(this.plycaErrorHandler.handle);
  }

*/
  public getTasks = (
    urlStringParams: string
  ): Observable<PaginationDTO<TaskDTO>> => {
    let url = this._configuration.ServerWithUserApiUrl + 'tasks';
    if (urlStringParams) {
      url += '?' + urlStringParams;
    }
    console.log('getTasks URL: ' + url);
    return this._http
      .get<PaginationDTO<TaskDTO>>(url);
    // .map((response: Response) => {
    //   return response.json() as PaginationDTO<TaskDTO>;
    // })
    // .catch(this.plycaErrorHandler.handle);
  };

  // pide la tarea y la actualiza en el store
  protected getTask(idTarea: string, withWork: boolean, withActions: boolean): Observable<TaskDTO> {
    let url = this._configuration.ServerWithUserApiUrl + 'tasks/' + idTarea;
    if (withWork) {
      if (withActions) {
        url = url + '?expand=expansionSet:WITH_WORK_WITH_ACTIONS,division.project.expansionSet:minimal';
      } else {
          url = url + '?expand=expansionSet:WITH_WORK_WITHOUT_ACTIONS,division.project.expansionSet:minimal,division.project.organizationalUnit,division.project.organizationalUnit.entityDTO';
      }
    } else {
      url = url + '?expand=expansionSet:WITHOUT_WORK,division.project.expansionSet:minimal';
    }
    return this._http.get<TaskDTO>(url).pipe(
      catchError(err => observableThrowError(err)),
      map((task: TaskDTO) => {
        this.store.dispatch(UPDATE_PENDINGTASK({ task: task }));
        return task;
      })
      // ,
      // map((task: TaskDTO) => {
      //   this.helpService.showContextHelp(task);
      //   return task;
      // })
    );
  }

  public getTaskWithoutWork(idTarea: string): Observable<TaskDTO> {
    return this.getTask(idTarea, false, false);
  }


  public getTaskForWork(idTarea: string): Observable<TaskDTO> {
    return this.getTask(idTarea, true, false);
  }

  public getTaskWithActions(idTarea: string): Observable<TaskDTO> {
    return this.getTask(idTarea, true, true);
  }

  public saveWork(task: TaskDTO, reactive = false): Observable<TaskDTO | any> {
    let links: Link[];
    links = task.work.links;
    console.log('task.work  ', task.work);
    if (reactive) {
      return this.getTaskWithActions(task.identifier);
    } else {
      console.log('url ', links[0].href);
      return this._http.put(links[0].href, this.work2String(task.work)).pipe(
        flatMap(() => {
          // actualizamos opciones disponibles consultando de nuevo la tarea
          return this.getTaskWithActions(task.identifier);
        })
      );
    }
  }

  /*
   * METODOS PRIVADOS PARA INVOCACION A LAS APIS
   */

  private internalLockTask(idTarea: string): Observable<Object> {
    //   let url = this._configuration.ServerWithUserApiUrl + "tasks?page=2&size=10&types=TIPO_ALARMA"
    let url =
      this._configuration.ServerWithUserApiUrl + 'tasks/' + idTarea + '/lock';
    return this._http.put(url, '');
  }

  private internalKeepTask(task: TaskDTO): Observable<TaskDTO> {
    let availableActions: Array<ActionDTO> = task.availableActions.actions;
    let url: string;
    for (let i in availableActions) {
      if (availableActions[i].identifier === ActionTypeDTO.TASK_MANTAIN) {
        let links: Link[];
        links = availableActions[i].links;
        url = links[0].href;
        break;
      }
    }
    if (url) {
      return this._http.put(url, this.task2String(task)).pipe(
        map(() => {
          console.log('response mantainTask');
          return task;
        })
      );
    } else {
      console.log('URL para mantener no disponible');
      return null;
    }
  }

  private internalUnlockTask(task: TaskDTO): Observable<TaskDTO> {
    let availableActions: Array<ActionDTO> = task.availableActions.actions;
    let url: string;
    for (let action of availableActions) {
      if (action.identifier === ActionTypeDTO.TASK_UNLOCK) {
        let links: Link[];
        links = action.links;
        url = links[0].href;
        break;
      }
    }
    if (url) {



      return this._http.put(url, this.task2String(task)).pipe(

        map(() => {
          console.log('response desbloquear');
          return task;
        })
      );
    } else {
      console.log('URL para desbloquear no disponible');
      return observableOf(undefined);
    }
  }

  private internalRedirectTask(task: TaskDTO, inboxIdentifier: string): Observable<TaskDTO> {
    let availableActions: Array<ActionDTO> = task.availableActions.actions;
    let url: string;
    for (let action of availableActions) {
      if (action.identifier === ActionTypeDTO.TASK_REDIRECT) {
        let links: Link[];
        links = action.links;
        url = links[0].href;
        break;
      }
    }
    if (url) {
      url = url.replace('inboxId', inboxIdentifier);
      return this._http.put(url, this.task2String(task)).pipe(
        map(() => {
          console.log('response redireccionar');
          return task;
        })
      );
    } else {
      console.log('URL para redireccionar no disponible');
      return observableOf(undefined);
    }
  }

  public isActionAvailable(task: TaskDTO, actionType: ActionTypeDTO) {
    let action = task.availableActions.actions.filter(
      x => x.identifier === actionType
    );
    return action.length > 0;
  }
  
  private exitsActionTypeDispacth(availableActions: Array<ActionDTO>) {
    let url: string;
    if (availableActions) {
      for (let i in availableActions) {
        if (availableActions[i].identifier === ActionTypeDTO.TASK_DISPATCH) {
          let links: Link[];
          links = availableActions[i].links;
          url = links[0].href;
          break;
        }
      }
    }
    return url;
  }

  private internalDispatchTask(task: TaskDTO): Observable<TaskDTO> {
    let availableActions: Array<ActionDTO> = task.availableActions.actions;
    let url = this.exitsActionTypeDispacth(availableActions);
    if (!url) {
      availableActions = task?.work?.availableActions?.actions;
      url = this.exitsActionTypeDispacth(availableActions);
    }

    // si se intenta despachar una tarea sin que la acción esté disponible, lanzamos error
    if (!url) {
      return observableThrowError(this.translationService.instant('BaseTask.Errors.notDispatchAction'));
    }
    return this._http.put(url, this.task2String(task)).pipe(
      map(() => {
        console.log('response dispatchTask');
        return task;
      })
    );
  }

  /*
   * GESTION DEL HILO DE ACTUALIZACION DE TAREAS
   */
  initTasksThread() {
    if (!this.taskThread) {
      this.consultaTareas(this.NO_MOSTRAR_MENSAJE_TAREAS_NUEVAS);
      // pedimos las tareas cada 300 000 segundos
      this.taskThread = interval(this.appConfig.getValue('task.refresh.interval')).subscribe(() => {
        console.log('Hilo de consulta de tareas');
        this.consultaTareas(this.MOSTRAR_MENSAJE_TAREAS_NUEVAS);
      });
    }
  }

  stopTasksThread() {
    if (this.taskThread) {
      this.taskThread.unsubscribe();
      this.taskThread = undefined;
    }
  }

  /*
   * UTILIDADES PARA EL INTERFAZ
   */
  public getTaskIcon(t: TaskDTO): string {
    let texto = 'otro';
    if (
      t.status === TaskStatusDTO.LOCKED
    ) {
      texto = 'fa fa-lg fa-lock text-danger';
    } else if (t.status === TaskStatusDTO.LOGICAL_LOCKED) {
      texto = 'fa fa-lg fa-lock text-warning';
    } else if (
      t.lockedForSupport
    ) {
      texto = ' fa-lg fas fa-wrench';
    } else if (!this.isActiveTask(t)) {
      texto = 'fa fa-lg fa-ban text-danger';
    } else if (t.type === TaskTypeDTO.TIPO_FIRMA) {
      texto = 'fa fa-lg fa-pen-nib';
    } else if (t.type === TaskTypeDTO.TIPO_FIRMA_MASIVA) {
      texto = 'fa fa-lg fa-pen-nib';
    } else if (t.type === TaskTypeDTO.TIPO_OPTATIVA) {
      texto = 'fa fa-lg fa-question';
    } else if (t.type === TaskTypeDTO.TIPO_ASIGNACION) {
      texto = 'fa fa-lg fa-user';
    } else if (t.type === TaskTypeDTO.TIPO_CUMPLIMENTACION) {
      texto = 'fa fa-lg fa-edit';
    } else if (t.type === TaskTypeDTO.TIPO_OTROS) {
      texto = 'fa fa-lg fa-clipboard';
    } else if (t.type === TaskTypeDTO.TIPO_ALARMA) {
      texto = 'fa fa-lg fa-bell';
    } else if (t.type === TaskTypeDTO.TIPO_VIRTUAL) {
      texto = 'fa fa-lg fa-info';
    }
    return texto;
  }


  isLockedTask(task: TaskDTO) {
    // Para mostrar el enlace de la tarea activo
    // return (task.lockedBy !== undefined || task.status === TaskStatusDTO.LOCKED || task.status === TaskStatusDTO.LOGICAL_LOCKED);
    return (task.status === TaskStatusDTO.LOCKED || task.status === TaskStatusDTO.LOGICAL_LOCKED);
  }

  isActiveTask(task: TaskDTO) {
    //    return task.workAvailable;
    return true;
  }

  private task2String(task: TaskDTO): string {
    if (task) {
      this.cleanWorkForSubmission(task.work);
    }
    return JSON.stringify(task, (k, v) => (k === '_parent' ? undefined : v));
  }

  private work2String(work: WorkDTO): string {
    this.cleanWorkForSubmission(work);
    return JSON.stringify(work, (k, v) => (k === '_parent' ? undefined : v));
  }

  private cleanWorkForSubmission(work: WorkDTO): void {
    // eliminar errores validacion previos recibidos previamente desde servidor
    if (work) {
      work.validationResult = null;
    }
  }

}
